export default __webpack_public_path__ + "static/media/portada1.869048a0.png";